import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The Worklist's old path, kept as a redirect: it was the landing page for long enough to be bookmarked,
 * linked from notifications, and pasted between colleagues.
 *
 * `href` rather than `to` because those links carry state — an open task, an org filter, a page index,
 * all of which live in the query string. `to` would drop it and land the person on an unfiltered Home.
 */
export const Route = createFileRoute('/_auth/worklist/')({
  beforeLoad: ({ location }) => {
    throw redirect({ href: `/home${location.searchStr}` });
  },
});
